// Palette de couleurs principale
export const primaryColor = '#28a745'; // Vert principal
export const primaryHoverColor = '#218838'; // Vert plus foncé pour les survols
export const secondaryColor = '#6c757d'; // Gris secondaire
export const secondaryHoverColor = '#5a6268'; // Gris secondaire plus foncé pour les survols

// Couleurs d'accentuation
export const accentColor = '#ffc107'; // Jaune/orange pour accentuation
export const accentHoverColor = '#e0a800'; // Jaune/orange plus foncé pour les survols

// Couleurs de fond
export const backgroundColor = '#f8f9fa'; // Fond clair
export const backgroundDarkColor = '#e9ecef'; // Fond légèrement plus foncé

// Couleurs de texte
export const textColor = '#212529'; // Texte foncé standard
export const textLightColor = '#6c757d'; // Texte gris clair
export const textOnPrimaryColor = '#ffffff'; // Texte sur fond de couleur primaire

// Couleurs de statut
export const successColor = '#28a745'; // Vert pour succès (même que primaire)
export const warningColor = '#ffc107'; // Jaune pour avertissement (même que accent)
export const dangerColor = '#dc3545'; // Rouge pour erreur
export const infoColor = '#17a2b8'; // Bleu pour information

// Couleurs de bordure
export const borderColor = '#dee2e6'; // Bordure légère
export const borderDarkColor = '#ced4da'; // Bordure plus visible

// Exports supplémentaires pour la cohérence du thème
export const theme = {
  primary: primaryColor,
  primaryHover: primaryHoverColor,
  secondary: secondaryColor,
  secondaryHover: secondaryHoverColor,
  accent: accentColor,
  accentHover: accentHoverColor,
  background: backgroundColor,
  backgroundDark: backgroundDarkColor,
  text: textColor,
  textLight: textLightColor,
  textOnPrimary: textOnPrimaryColor,
  success: successColor,
  warning: warningColor,
  danger: dangerColor,
  info: infoColor,
  border: borderColor,
  borderDark: borderDarkColor
};

export default theme;